import { render, staticRenderFns } from "./itemsRevenue.vue?vue&type=template&id=297c95d0&scoped=true&"
import script from "./itemsRevenue.vue?vue&type=script&lang=js&"
export * from "./itemsRevenue.vue?vue&type=script&lang=js&"
import style0 from "./itemsRevenue.vue?vue&type=style&index=0&id=297c95d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297c95d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDataTable,VSelect})
